import { BadgeTemplateTwoSidePreview } from '../../../../../ui/features/badge-preview/components/BadgeTemplateTwoSidePreview';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
export const BadgeCreateWizardStepContainer = ({ headerText, formSettings, badgeTemplateSelected, fixedBadgePreviewPosition, children, }) => {
    const { t } = useBadgingTranslation();
    return (React.createElement(Grid, { className: 'badge-create-wizard-step-container', container: true, spacing: { xs: 2, lg: 4 }, sx: {
            paddingTop: {
                md: '0 !important', // Cancels padding set by the FullScreenWizard component to provide more space for the fixed container
            },
        } },
        React.createElement(Grid, { item: true, xs: 12, md: 6 },
            React.createElement(Typography, { variant: 'h1', mb: 3 }, headerText),
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                } }, children)),
        React.createElement(Grid, { item: true, xs: 12, md: 6 },
            React.createElement(Box, { className: 'box-1', sx: Object.assign({ background: themeColors.surface.secondary }, (fixedBadgePreviewPosition
                    ? {
                        position: { md: 'fixed' },
                        width: { md: 'calc(50% - 3rem)' }, // Recalculates width, accounting for padding
                        top: { md: '10.25rem' },
                        height: { md: 'calc(100vh - 15.5625rem)' }, // Subtracts heights of other elements to calculate the remaining height
                    }
                    : {
                        height: { md: 'calc(100vh - 15.5625rem)' },
                    })) }, badgeTemplateSelected ? (React.createElement(BadgeTemplateTwoSidePreview, { badgeTemplateClassifier: badgeTemplateSelected, badgeTemplateBack: badgeTemplateSelected.data.badgeTemplateBack, badgeTemplateFront: badgeTemplateSelected.data.badgeTemplateFront, formSettings: formSettings !== null && formSettings !== void 0 ? formSettings : badgeTemplateSelected.data.defaultFormSettings, account: badgeTemplateSelected.data.defaultSampleAccountData })) : (React.createElement(Box, { sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', p: 6 } },
                React.createElement(Typography, { variant: 'subtitle2' }, t('badges.create.wizard.templateNotSelected'))))))));
};
